<template>
  <div class="base-content bg-gray-50 min-h-screen w-full">
    <slot />
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.base-content {
  padding-top: 69px;
  padding-left: 230px;
}
@media screen and (max-width: 1024px) and (min-width: 769px) {
  .base-content {
    padding-left: 54px;
  }
}
@media screen and (max-width: 768px) {
  .base-content {
    padding-left: 0;
  }
}
</style>
